import {addBreadcrumb} from '@sentry/browser';

import M from '../store/mutation-types';

const CONTROLLER_LOGIN_ENDPOINT = 'auth/login-integration';

export function doLogin({commit, dispatch, state}, {userid}) {
	commit(M.SHOW_LOADER);
	addBreadcrumb({message: 'Login attempt with userid: ' + userid});

	if (! state.controller) {
		commit(M.SET_ERROR, 'Unable to communicate with server. (ERR_UNKNOWN_API_SERVER)');
		commit(M.HIDE_LOADER);
		return;
	}

	fetch(state.controller + CONTROLLER_LOGIN_ENDPOINT, {
		method: 'POST',
		mode: 'cors',
		cache: 'no-cache',
		headers: {
			'X-Requested-With': 'XMLHttpRequest',
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({
			username: userid
		}),
	}).then((resp) => {
		if (!resp.ok) {
			throw new Error(`Unable to communicate with server. (ERR_API_SERVER_ERROR_${resp.status})`);
		}

		return resp.json();
	}).then((json) => {
		dispatch('processOperatorToken', json.token);
	}).catch((err) => {
		if (err.message === 'Failed to fetch') {
			commit(M.SET_ERROR, 'Unable to communicate with server. (ERR_API_FETCH)');
		} else {
			commit(M.SET_ERROR, err.message);
		}
	}).finally(() => {
		commit(M.HIDE_LOADER);
	});
}
